import React, {useRef, useState} from 'react';
import styles from "./term-sheet-participants.module.scss";
import {Col, Row, Table} from "react-bootstrap";
import detailsArrowIcon from "../../../../../../assets/table-details-arrow.svg";
import ModalCustom from "../../../../../../components/modal/modal";
import ParticipantDetailsModalContent from "../participant-details-modal-content/participant-details-modal-content";

const TermSheetParticipants = ({context, admin}) => {
  //Modal State
  const [showModal, setShowModal] = useState(false);
  const selectedParticipant = useRef({});
  const { termSheet, editAllowed } = context;
  const [participantList, setParticipantList] = useState(termSheet.participantList);
  console.log(termSheet.participantList);
  const tableHeaders = [
    {value: 'Role', class: ''},
    {value: 'Institution', class: ''},
    {value: 'Primary Contact', class: ''},
    {value: 'Email', class: ''}
  ]

  const showParticipantDetails = (participant) => {
    selectedParticipant.current = participant;
    setShowModal(true)
  }

  return (
    <div className={`${styles['term-sheet-participants']} ${styles['panel']}`} >
      <Row>
        <Col>
          <div className={styles['table-heading']}>
            Participants
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <Table responsive>
            <thead>
            <tr>
              {tableHeaders.map(
                (header, index) => {
                  return <th className={styles[header['class']]} key={index}>{header.value}</th>
                }
              )}
            </tr>
            </thead>
            <tbody>
            {
              participantList.map((p, index) => {
                return (
                  <tr key={index}>
                    <td>{p.role}</td>
                    <td>{p.institutionName}</td>
                    <td>{`${p.primaryContact.firstName} ${p.primaryContact.middleInitial} ${p.primaryContact.lastName}`}</td>
                    <td>{p.emailAddress}</td>
                    <td className={styles['detail-arrow']} >
                      <img alt="See Details" src={detailsArrowIcon} onClick={()=>showParticipantDetails(p)} />
                    </td>
                  </tr>
                )
              })
            }
            </tbody>
          </Table>
          {
            participantList.length > 0 ? ''
              : <div className={styles['no-data']}>No participants to display.</div>
          }
        </Col>
      </Row>
      <ModalCustom
        show={showModal}
        title="Participant Details"
        onClose={() => setShowModal(false)}
        component={<ParticipantDetailsModalContent termSheet={termSheet} participant={selectedParticipant} setParticipantList={setParticipantList} onClose={() => setShowModal(false)} admin={admin} editAllowed={editAllowed}/>}
        style={styles['participant-details-modal']} />
    </div>
  )
}

export default TermSheetParticipants;
